import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Input,
  Label,
} from "@egaranti/components";

import { useState } from "react";
import { useTranslation } from "react-i18next";

const BillUploadDialog = ({ open, onOpenChange, onUpload }) => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setIsUploading(true);
    try {
      await onUpload(file);
      onOpenChange(false);
    } finally {
      setIsUploading(false);
      setFile(null);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("individualCustomers.uploadBill")}
          </AlertDialogTitle>
        </AlertDialogHeader>
        <div className="space-y-2 py-4">
          <Label>{t("payment.pastPayments.table.invoice")}</Label>
          <Input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            className="w-full"
            disabled={isUploading}
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => onOpenChange(false)}
            disabled={isUploading}
          >
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleUpload}
            disabled={!file || isUploading}
          >
            {t("common.save")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default BillUploadDialog;
